/** Three container:
 * <div> below is the container of the canvas
 * created in the threeEntryPoint (index.js);
 * optionally, create a canvas here instead of <div> 
 * 
 * @ref attribute gets a reference to the div element
 * @threeEntryPoint() is called when the function componentDidMount() 
 * is automatically called by React, when the component is mounted.
 */

import React from 'react';
import Sidebar from '../Sidebar';
import SceneController from "../../home/SceneController";

export default class Home extends React.Component {
    constructor() {
        super();
        this.sceneController = new SceneController();
    }

    componentDidMount() {
        this.sceneController.setup();
    };

    componentWillUnmount() {
        if (this.sceneController) this.sceneController.dispose();
    };

    render() {
        return (
            <>
                <Sidebar />
                <div ref={element => this.threeRootElement = element} />
            </>
        );
    }
}





